import * as React from 'react';
import { ArticleOrderDraft, ItemValidationResult } from '../../domain/Order';
import ValidationResult from './ValidationResult';

interface Props {
    articlesOrdersDrafts: ArticleOrderDraft[];
    itemValidationResult: ItemValidationResult[];
}

class PopupOrdersImported extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-text">Your file has been imported</div>
                <div className="popup-text">
                    {this.props.itemValidationResult.length > 0 && (
                        <ValidationResult
                            itemValidationResult={this.props.itemValidationResult}
                            label="File contains item(s) not enabled for ordering. These items have been omitted."
                        />
                    )}
                </div>
            </>
        );
    }
}

export default PopupOrdersImported;



// WEBPACK FOOTER //
// ./src/view/popup/PopupOrdersImported.tsx